import {
    HIDE_GLOBAL_MODAL,
    SHOW_GLOBAL_MODAL,
    SET_GLOBAL_MODAL_TITLE,
    SET_GLOBAL_MODAL_WIDTH,
    SET_GLOBAL_MODAL_CONTENT,
} from '../mutation-types'

const state = {
    modal: {
        active: false,
        width: '75%',
        title: '',
        content: '',
    },
}

const getters = {
    getModalTitle: state => state.modal.title,
    getModalContent: state => state.modal.content,
    getModalWidth: state => state.modal.width,
    isGlobalModalActive: state => state.modal.active,
}

const actions = {
    hideGlobalModal({commit}) {
        commit(HIDE_GLOBAL_MODAL)
    },
    showGlobalModal({commit}) {
        commit(SHOW_GLOBAL_MODAL)
    },
    setGlobalModalContent({commit}, content) {
        commit(SET_GLOBAL_MODAL_CONTENT, content)
    },
    setGlobalModalWidth({commit}, title) {
        commit(SET_GLOBAL_MODAL_WIDTH, title)
    },
    setGlobalModalTitle({commit}, title) {
        commit(SET_GLOBAL_MODAL_TITLE, title)
    },
}

const mutations = {
    [SHOW_GLOBAL_MODAL](state) {
        state.modal.active = true
    },
    [HIDE_GLOBAL_MODAL](state) {
        state.modal.active = false
    },
    [SET_GLOBAL_MODAL_CONTENT](state, content) {
        state.modal.content = content
    },
    [SET_GLOBAL_MODAL_TITLE](state, title) {
        state.modal.title = title
    },
    [SET_GLOBAL_MODAL_WIDTH](state, width) {
        state.modal.width = width
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
